// Mirror of `personal_admon_backend/authz/policy.py` ACTIONS matrix.
// Used to hide affordances the backend would 403 on anyway.
// Server is the source of truth — this is for UX, not for security.

const ACTIONS = {
  'workspace.read':              ['Owner', 'Co-Owner', 'Member', 'Advisor', 'Viewer'],
  'workspace.update':            ['Owner', 'Co-Owner'],
  'workspace.delete':            ['Owner'],
  'workspace.transfer_ownership':['Owner'],

  'member.read':                 ['Owner', 'Co-Owner'],
  'member.invite':               ['Owner', 'Co-Owner'],
  'member.remove':               ['Owner', 'Co-Owner'],
  'member.self_leave':           ['Co-Owner', 'Member', 'Advisor', 'Viewer'],

  'movement.create':             ['Owner', 'Co-Owner', 'Member'],
  'movement.read.summary':       ['Owner', 'Co-Owner', 'Member', 'Advisor', 'Viewer'],
  'movement.read.standard':      ['Owner', 'Co-Owner', 'Member', 'Advisor', 'Viewer'],
  'movement.update.own':         ['Owner', 'Co-Owner', 'Member'],
  'movement.update.any':         ['Owner', 'Co-Owner'],
  'movement.delete.own':         ['Owner', 'Co-Owner', 'Member'],
  'movement.delete.any':         ['Owner', 'Co-Owner'],

  'category.create':             ['Owner', 'Co-Owner', 'Member'],
  'category.update':             ['Owner', 'Co-Owner'],
  'category.delete':             ['Owner', 'Co-Owner'],

  'account.read':                ['Owner', 'Co-Owner', 'Member', 'Advisor', 'Viewer'],
  'account.create':              ['Owner', 'Co-Owner', 'Member'],
  'account.update':              ['Owner', 'Co-Owner', 'Member'],
  'account.delete':              ['Owner', 'Co-Owner'],

  'tag.read':                    ['Owner', 'Co-Owner', 'Member', 'Advisor', 'Viewer'],
  'tag.create':                  ['Owner', 'Co-Owner', 'Member'],
  'tag.update':                  ['Owner', 'Co-Owner', 'Member'],
  'tag.delete':                  ['Owner', 'Co-Owner'],

  'goal.read':                   ['Owner', 'Co-Owner', 'Member', 'Advisor', 'Viewer'],
  'goal.create':                 ['Owner', 'Co-Owner', 'Member'],
  'goal.update':                 ['Owner', 'Co-Owner', 'Member'],
  'goal.delete':                 ['Owner', 'Co-Owner'],

  'source_file.read':            ['Owner', 'Co-Owner', 'Member', 'Advisor'],
  'source_file.delete':          ['Owner', 'Co-Owner'],

  'statement.upload':            ['Owner', 'Co-Owner', 'Member'],
  'statement.read':              ['Owner', 'Co-Owner', 'Member', 'Advisor'],
  'statement.cancel':            ['Owner', 'Co-Owner', 'Member'],

  'repair.review':               ['Owner', 'Co-Owner'],
  'repair.apply':                ['Owner', 'Co-Owner'],


  'grant.request':               ['Advisor'],
  'grant.approve':               ['Owner'],
  'grant.revoke':                ['Owner'],
  'grant.read.own':              ['Owner', 'Co-Owner', 'Advisor'],
};

export function can(workspaceRole, action) {
  if (!workspaceRole) return false;
  const allowed = ACTIONS[action];
  if (!allowed) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`can(): unknown action ${action}`);
    }
    return false;
  }
  return allowed.includes(workspaceRole);
}
